import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetHealthInsuranceById } from 'src/hooks/health-insurance/get-health-insurance-by-id.hook';
import { useCreateHealthInsurance } from 'src/hooks/health-insurance/create-health-insurance.hook';
import { useUpdateHealthInsurance } from 'src/hooks/health-insurance/update-health-insurance.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { HealthInsuranceForm } from './components/health-insurance-form';
import { IHealthInsuranceTableValues } from './health-insurance-interfaces';

const ChangeHealthInsurance = ({
  id,
  onClose,
  healthInsuranceCardName,
}: {
  id?: string;
  onClose: () => void;
  healthInsuranceCardName?: string;
}) => {
  const { healthInsurance, loading } = useGetHealthInsuranceById(id);
  const { createHealthInsurance, loading: createLoading } = useCreateHealthInsurance({
    onSuccess: onClose,
  });
  const { updateHealthInsurance, loading: updateLoading } = useUpdateHealthInsurance({
    onSuccess: onClose,
  });

  const currentCompanyId = useGetCurrentCompanyId();

  const { _id, name, healthInsuranceNumbers, houseNumber, street, city, zipCode } =
    healthInsurance || {};

  const handler = _id ? updateHealthInsurance : createHealthInsurance;
  const loader = _id ? updateLoading : createLoading;

  const isEdit = healthInsurance?._id;

  const initialValue = isEdit
    ? {
        name,
        healthInsuranceNumbers,
        houseNumber,
        street,
        city,
        zipCode,
      }
    : ({
        ...(healthInsuranceCardName && { name: healthInsuranceCardName }),
        healthInsuranceNumbers: [{}],
      } as IHealthInsuranceTableValues);

  const onFinish = (values: IHealthInsuranceTableValues) => {
    handler({
      variables: {
        payload: {
          ...(_id && { _id }),
          ...values,
          companyId: currentCompanyId,
        },
      },
    });
  };

  if (loading) return <Loader />;

  return (
    <HealthInsuranceForm
      isEdit={isEdit}
      initialValues={initialValue}
      onClose={onClose}
      loading={loader}
      onFinishHandler={onFinish}
    />
  );
};

export default ChangeHealthInsurance;
